/**
 * Initializes an Alpine.js data object to manage video playback from a custom play button.
 * Key features include:
 * 1. Play Control: Hides the play button and enables video controls upon clicking the play button.
 * 2. Video Playback: Starts video playback automatically when the play button is clicked.
 */

function playButtonVideo() {
  return {
    init() {
      const video = this.$el.querySelector('video');
      const playButton = this.$el.querySelector('.play-button');

      playButton.addEventListener('click', () => {
          playButton.style.display = 'none';
          video.setAttribute('controls', '');
          video.setAttribute('autoplay', 'true');
          video.play()
      });
    }
  };
}

document.addEventListener('alpine:init', () => {
  Alpine.data('playButtonVideo', playButtonVideo);
});